import React from 'react';

import Input from './Input';

const InputContainer = ({ type, ...restProps }) => {
  const handleKeyPress = (event) => {
    const inputMaxLength = restProps.maxLength || restProps.maxlength;

    if (
      type === 'number' &&
      (event.code === 'Minus' ||
        event.code === 'NumpadSubtract' ||
        event.key === '+' ||
        (inputMaxLength && event.target.value.length >= inputMaxLength))
    ) {
      event.preventDefault();
    }
  };

  return <Input onKeyPress={handleKeyPress} {...restProps} type={type} />;
};

export default React.memo(InputContainer);
